import { FormModel } from '../../../../../components/Form';
import { ReactNode } from 'react';
import { GeneralForm } from '../AddEditVenueConfiguration/General/generalForm';

export const bulkGeneralForm = (
  strings: any,
  hourlyPricing: boolean,
  serviceChargeDropdown: boolean,
  paymentScheduleNode: ReactNode,
): FormModel[] => {
  return GeneralForm(strings, hourlyPricing, serviceChargeDropdown, paymentScheduleNode).map(field => {
    if (field.field === 'venues') {
      return { ...field, field: 'venueIds', isMulti: true };
    }
    if (field.field === 'eventTypeId') {
      return { ...field, field: 'eventTypeIds', isMulti: true };
    }
    return field;
  });
};

export const bulkMappingForm = (_strings: any): FormModel[] => [];
